export const NUSGDG_YOUTUBE_CHANNEL = "https://www.youtube.com/@nusgamesdevelopmentgroup9090";
